import React from 'react';
import { Helmet } from 'react-helmet-async';
import './App.css';
import AlertBanner from './components/AlertBanner';
import Hero from './components/Hero';
import ScamSteps from './components/ScamSteps';
import Testimonials from './components/Testimonials';
import Evidence from './components/Evidence';
import HowToReport from './components/HowToReport';
import ProtectYourself from './components/ProtectYourself';
import Footer from './components/Footer';
import Ticker from './components/Ticker';

function App() {
  return (
    <div className="App">
      <Helmet>
        <title>⚠️ ARNAQUE JUMPVENDOR.COM — Fraude Confirmée | Témoignages & Signalement</title>
        <meta name="description" content="JumpVendor.com est un site d'arnaque qui piège les victimes via TikTok. Prélèvements cachés, abonnements frauduleux. Découvrez leur système et comment vous protéger." />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Article",
          "headline": "ARNAQUE JUMPVENDOR.COM — Site Frauduleux Confirmé",
          "description": "Exposition du système d'arnaque de JumpVendor.com : faux liens TikTok, prélèvements multiples, abonnements cachés.",
          "author": { "@type": "Organization", "name": "JumpVendor Alert" },
          "datePublished": "2025-01-01",
          "dateModified": new Date().toISOString().split('T')[0]
        })}</script>
      </Helmet>

      <AlertBanner />
      <Ticker />
      <Hero />
      <ScamSteps />
      <Testimonials />
      <Evidence />
      <HowToReport />
      <ProtectYourself />
      <Footer />
    </div>
  );
}

export default App;
